import {
    Component,
    OnInit,
    OnDestroy,
    Renderer2,
    HostBinding
} from '@angular/core';
import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {AppService} from '@services/app.service';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  /* @HostBinding('class') class = 'login-box';*/
  public isAuthLoading = false;
  public isGoogleLoading = false;
  public isFacebookLoading = false;
  showPassword = false;
  userType: string = "";
  destroy$: Subject<boolean> = new Subject<boolean>();
  loginDetails: any;

  constructor(
    private renderer: Renderer2,
    private toastr: ToastrService,
    private appService: AppService,
    private router: Router,
    private spinner: NgxSpinnerService,
  ) {
  }

  ngOnInit() {
    this.renderer.addClass(
      document.querySelector('app-root'),
      'login-page'
    );
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  loginForm = new UntypedFormGroup({
    userName: new UntypedFormControl('', [Validators.required]),
    password: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
  });


  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.loginAuth();
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  loginAuth() {
    this.spinner.show();
    this.appService.loginAuth(this.loginForm.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        this.toastr.success('Login Successful');
        this.loginDetails = data;
        console.log(data)
        localStorage.setItem('authToken', this.loginDetails.authHeader);
        localStorage.setItem('userType', this.loginDetails.regDetails.userType);
        localStorage.setItem('userId', String(this.loginDetails.regDetails.userId));
        localStorage.setItem('role',this.loginDetails.regDetails.employeeRole);
        if(this.loginDetails.regDetails.employeeRole == 'Admin'){
        this.router.navigate(['/main/new-joining-form']);
        }else if(this.loginDetails.regDetails.employeeRole == 'Data Entry Operator'){
        localStorage.setItem('formId', btoa(String(this.loginDetails.regDetails.formId)));
        this.router.navigate(['/main/employee-worksheet-entry']);
        }else if(this.loginDetails.regDetails.employeeRole == 'Software Developer' || this.loginDetails.regDetails.employeeRole == 'Tech Lead'
          || this.loginDetails.regDetails.employeeRole == 'Software Tester'){
        localStorage.setItem('formId', btoa(String(this.loginDetails.regDetails.formId)));
        this.router.navigate(['/main/development-worksheet-entry']);
        }
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.error.message || "Something Went Wrong,Please Try Again...")
      })
  }

  ngOnDestroy() {
    this.renderer.removeClass(
      document.querySelector('app-root'),
      'login-page'
    );
  }
}
